// extracted by mini-css-extract-plugin
export default {"upwork":"style_upwork__HfBeM","fiverr":"style_fiverr__E0Hu0","fiverrp":"style_fiverrp__eEYZo"};